import type { Organization } from '@hotjar/navigation/src/types';

export const filterData = (searchTerm: string, data: Organization[]): Organization[] => {
  const regexp = new RegExp(searchTerm, 'i');
  return data
    .filter((organization) => {
      return (
        regexp.test(organization.name) || organization.sites.some((site) => regexp.test(site.name))
      );
    })
    .reduce((acc, organization) => {
      if (regexp.test(organization.name)) {
        return [...acc, organization];
      }

      const sites = organization.sites.filter((site) => regexp.test(site.name));
      return [...acc, { ...organization, sites }];
    }, [] as Organization[]);
};
